<form class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1">
      <div class="">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="albums"></ion-icon>
          </div>
          <div>
            <p class="title">Templates</p>
          </div>
        </div>
      </div>
    </div>
  
    <div class="form-container ion-padding-horizontal" *ngIf="allInventoryTemplates">

      <div class="row">
        <div class="col-4 p-1" *ngFor="let template of sanitizedTemplates">
          <div class="template-main-container">
            <div class="template-title-container">
              <p class="title mb-0 mb-1">{{template.name}}</p>
            </div>
            <div class="cover-container">
              <!-- Use the sanitized content here -->
              <div class="cover-page" [innerHtml]="template.content"></div>
              <div class="action-btns-container">
                <!-- Buttons here, if needed -->
              </div>
            </div>
      
            <div class="select-container">
              <input
                class="d-none"
                type="radio"
                name="template"
                [checked]="template.templateId === selectedTemplateId"
                [attr.id]="template.templateId"
                [value]="template.templateId"
                [(ngModel)]="selectedTemplateId"
              />
              <label
                class="select-btn checkbox-label"
                [attr.for]="template.templateId"
                (click)="changeSelectedTemplate(template.templateId)"
              >
                {{ selectedTemplateId === template.templateId ? 'Selected' : 'Select' }}
              </label>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn invisible">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn invisible">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn invisible">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</form>
